import { categoryList } from "@/mocks/categories";

export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Artistic%20overhead%20flat%20lay%20of%20colorful%20sneakers%20denim%20jackets%20graphic%20t-shirts%20and%20baseball%20caps%20arranged%20in%20circular%20pattern%20on%20warm%20cream%20textured%20marble%20surface%2C%20soft%20morning%20sunlight%20casting%20gentle%20shadows%2C%20editorial%20fashion%20photography%2C%20clean%20minimalist%20composition%20with%20negative%20space%2C%20warm%20earthy%20tones%20with%20subtle%20pastel%20accents&width=1800&height=1000&seq=hero-main-marble-v1&orientation=landscape)`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/50 via-background-50/30 to-background-50/80"></div>

      <div className="relative z-10 w-full section-container text-center py-16 md:py-20 mt-4">
        <div className="flex items-center justify-center gap-2 mb-4">
          <span className="px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-800 whitespace-nowrap">
            Updated Weekly
          </span>
          <span className="px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-800 whitespace-nowrap">
            Community Verified
          </span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-extrabold text-foreground-950 leading-tight max-w-[800px] mx-auto">
          Discover the Best{" "}
          <span className="text-primary-500">Pandabuy Spreadsheet</span>
          {" "}for 2026
        </h1>

        <p className="mt-5 md:mt-6 text-base md:text-lg text-foreground-700 max-w-[640px] mx-auto leading-relaxed">
          A curated database of the most updated pandabuy spreadsheet collections — including streetwear, sneakers, luxury finds, and budget lists. Stop wasting time searching random links.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full font-semibold text-base whitespace-nowrap cursor-pointer transition-all duration-200 bg-primary-500 text-background-50 hover:bg-primary-600 hover:translate-y-[-1px]"
          >
            Explore Pandabuy Sheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href="/article/pandabuy-spreadsheet-guide"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full font-semibold text-base whitespace-nowrap cursor-pointer transition-all duration-200 border-2 border-foreground-900 text-foreground-900 hover:bg-foreground-900 hover:text-background-50 hover:translate-y-[-1px]"
          >
            Shopping Guide
            <i className="ri-book-open-line"></i>
          </a>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-[800px] mx-auto">
          {[
            { icon: "ri-refresh-line", text: "Updated Weekly Spreadsheets" },
            { icon: "ri-shield-check-line", text: "Verified Community Finds" },
            { icon: "ri-book-open-line", text: "Beginner-Friendly Guides" },
            { icon: "ri-alert-line", text: "Risk & Safety Explained" },
          ].map((item) => (
            <div key={item.text} className="flex flex-col items-center gap-2 p-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100">
                <i className={`${item.icon} text-primary-500 text-lg`}></i>
              </div>
              <span className="text-xs md:text-sm font-semibold text-foreground-800 text-center leading-tight whitespace-nowrap">
                {item.text}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-14 md:mt-16 flex items-center justify-center gap-3 md:gap-5 flex-wrap">
          {categoryList.slice(0, 8).map((cat, i) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50/90 backdrop-blur-sm border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
            >
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-[10px] font-bold">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="text-sm font-semibold text-foreground-800 group-hover:text-foreground-950 whitespace-nowrap">
                {cat.name}
              </span>
              <i className="ri-arrow-right-up-line text-xs text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
            </a>
          ))}
        </div>
      </div>

    </section>
  );
}